<template>
  <div id="app">
    <div class="login_page">
      <div></div>
      <div>
        <v-card elevation="6">
          <v-form ref="add_form" @submit.prevent="LogIn">
            <div class="logo">
              <img src="@/assets/logo3.jpeg" alt="">
            </div>
            <v-card-title>
              เข้าสู่ระบบ
            </v-card-title>
            <v-card-text>
              <div class="mt-2">
                <v-text-field type="text" color="#86bc3a" v-model="username" label="ชื่อผู้ใช้" prepend-inner-icon="mdi-account-outline" hide-details="auto" required outlined></v-text-field>
              </div>
              <div class="mt-2" style="margin-top: 10px">
<!--                <v-text-field color="#86bc3a" v-model="password" prepend-inner-icon="mdi-lock-outline" hide-details="auto" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'" name="input-10-1" label="รหัสผ่าน" @click:append="show = !show" required outlined></v-text-field>-->
                <v-text-field type="password" color="#86bc3a" label="รหัสผ่าน" v-model="password" prepend-inner-icon="mdi-lock-outline" hide-details="auto" required outlined></v-text-field>
              </div>
            </v-card-text>
            <v-spacer></v-spacer>
            <div class="btn_custom">
              <v-btn large class="grad-success-bg white--text mr-3 text_color" type="submit" width="100%" style="margin-right: 13px">
                ตกลง
              </v-btn>
            </div>
          </v-form>
        </v-card>
        <v-dialog v-model="alert_error" max-width="600">
          <v-card>
            <v-card-title>
              คำเตือน
            </v-card-title>

            <v-card-text>
              อีเมลและรหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="confirmError()">
                ตกลง
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-overlay :value="overlay" class="z_index">
          <div style="text-align: center">
            <v-progress-circular
                indeterminate
                size="70"
                width="7"
                color="#86bc3a"
            ></v-progress-circular>
            <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
          </div>
        </v-overlay>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import Swal from "sweetalert2";

export default {
  name: "Login",
  data() {
    return {
      show: false,
      username: null,
      password: null,
      overlay: false,
      alert_error: false,
    }
  },
  methods: {
   async LogIn() {
     let send_data = {
       username: this.username,
       password: this.password
     }
     try {
       this.overlay = true
       this.$store.state.user_data = send_data
       const response = await HTTP.post('/login', send_data)
       const config = {headers: {"Authorization": `Bearer ${response.data.access_token}`}}
       this.$store.state.token = response.data.access_token
       if (response.data.success === true) {
         try {
           const user = await HTTP.post('/profile', send_data, config)
           const userData = {
             access_token: response.data.access_token,
             status:response.data.status,
             userDetail: user.data
           }
           this.$store.commit('login_success', {
             access_token: userData.access_token,
             userDetail: userData.userDetail,
             status:response.data.status,
           })
           console.log(userData)
           this.overlay = false
           this.checkLogIn();
         }catch (error) {
           if (error.response.status == 401) {
             this.overlay = false
             Swal.fire({
               title: 'ไม่พบข้อมูล',
               text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง',
               icon: 'warning',
               showDenyButton: false,
               showCancelButton: false,
               confirmButtonText: `ตกลง`,
               denyButtonText: `ยกเลิก`,
             }).then((result) => {
               if (result.isConfirmed) {
                 this.confirmError();
               }
             });
           }
         }
       }
     }catch (error) {
       if (error.response.status == 401) {
         this.overlay = false
         Swal.fire({
           title: 'ไม่พบข้อมูล',
           text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง',
           icon: 'warning',
           showDenyButton: false,
           showCancelButton: false,
           confirmButtonText: `ตกลง`,
           denyButtonText: `ยกเลิก`,
         }).then((result) => {
           if (result.isConfirmed) {
             this.confirmError();
           }
         });
       }
     }
    },
    checkLogIn() {

     if (this.$store.state.access_token != null) {
       if (this.$store.state.status == 1) {
         this.$router.push('/')
       }
       else if (this.$store.state.userDetail.manage_stock != 0){
         this.$router.push('/count_stock/historylist')
       }
       else {
         this.$router.push('/stock')
       }
     }
    },
    confirmError() {
      this.username = '';
      this.password = '';
    }
  },
  mounted() {
    this.checkLogIn()
  }
}
</script>

<style scoped>
.btn_custom {
  padding: 15px;
  text-align: center;
}
.text_color {
  color: white;
  font-size: 18px;
}
.login_page {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 30% 40% 30%;
  justify-content: center;
  align-items: center;
  background-image: url('~@/assets/vuexy-login-bg.jpg');
  background-size: cover;
}
.logo {
  width: 70%;
  margin: auto;
  padding-top: 15px;
}
.logo>img {
  max-width: 100%;
}
@media only screen and (max-width: 1024px){
  .login_page {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: 20% 60% 20%;
    justify-content: center;
    align-items: center;
  }
}
@media only screen and (max-width: 500px){
  .login_page {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: 5% 90% 5%;
    justify-content: center;
    align-items: center;
  }
}
</style>
